import React from 'react';
import { observer } from 'mobx-react';

import { DEFAULT_TIME_FORMAT } from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { EventItemLayout, EventText, ItemDate } from './styles';
import { EventItemProps } from './types';

const EventItem: React.FunctionComponent<EventItemProps> = ({ activity, children, sessionUser, id, author }) => (
  <EventItemLayout id={id}>
    {author || activity.creator ? (
      <EventText id="activity-comment-message-author">
        <span>
          {author ?? activity.creator?.name}
          {!author && sessionUser.uuid === activity.creator?.uuid ? ' (You)' : ''}
        </span>{' '}
        {children}
      </EventText>
    ) : (
      <EventText>N/A</EventText>
    )}
    <ItemDate id="activity-comment-timestamp" data-testid="feed-event-time">
      {formatMoment(activity.created, DEFAULT_TIME_FORMAT)}
    </ItemDate>
  </EventItemLayout>
);

export default observer(EventItem);
